"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgComposeOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M24 19.4V28H8V6h10.6l2-2H6v26h20V17.4l-2 2z" }),
        React.createElement("path", { d: "M17.16 22H12v-5.16L25.81 3l.57.17a6.83 6.83 0 014.42 4.45l.17.57zM14 20h2.33L28.67 7.66a4.8 4.8 0 00-2.31-2.35L14 17.67z" })));
}
exports.default = SvgComposeOutline;
//# sourceMappingURL=ComposeOutline.js.map